import Vue from "vue"
import Vapi from "vuex-rest-api"

const concerts = new Vapi({
  axios: Vue.axios,
  queryParams: true,
  state: {
    concert: null,
    concerts: [],
    allConcerts: [],
    concertCategory: null,
    concertCategories: [],
    allConcertCategories: [],
  },
})

  // concerts
  // .get({
  //   action: "retrieveConcert",
  //   property: "concert",
  //   path: ({ id }) => `/concerts/${id}/`,
  // })
  // .get({
  //   action: "listConcerts",
  //   property: "concerts",
  //   path: "/concerts/",
  // })
  // .get({
  //   action: "listAllConcerts",
  //   property: "allConcerts",
  //   path: "/concerts/?no_page=1",
  // })
  // .post({
  //   action: "createConcert",
  //   property: "concert",
  //   path: "/concerts/",
  // })
  // .patch({
  //   action: "updateConcert",
  //   property: "concert",
  //   path: ({ id }) => `/concerts/${id}/`,
  // })
  // .delete({
  //   action: "destroyConcert",
  //   path: ({ id }) => `/concerts/${id}/`,
  // })

  .get({
    action: "listConcerts",
    property: "concerts",
    path: ({ showId }) => `/concerts/?show=${showId}`,
  })
  .get({
    action: "listAllConcerts",
    property: "allConcerts",
    path: ({ showId }) => `/concerts/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createConcert",
    path: "/concerts/",
  })
  .patch({
    action: "updateConcert",
    path: ({ id }) => `/concerts/${id}/`,
  })
  .delete({
    action: "destroyConcert",
    path: ({ id }) => `/concerts/${id}/`,
  })

  // concert categories
  .get({
    action: "listConcertCategories",
    property: "concerts",
    path: ({ showId }) => `/concert-categories/?show=${showId}`,
  })
  .get({
    action: "listAllConcertCategories",
    property: "allConcertCategories",
    path: ({ showId }) => `/concert-categories/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createConcertCategory",
    path: "/concert-categories/",
  })
  .patch({
    action: "updateConcertCategory",
    path: ({ id }) => `/concert-categories/${id}/`,
  })
  .delete({
    action: "destroyConcertCategory",
    path: ({ id }) => `/concert-categories/${id}/`,
  })

  // finalize
  .getStore()

export default concerts
